import { categoryIcons, materialIconPrefix } from "@entrilia/shared/components/categoryIcons";
import { autoFormatCamelCase } from "@entrilia/shared/utilities/stringHelper";
import { brandIconOptions } from "./brandIconOptions";

export interface IconOption {
  iconName: string;
  label: string;
}

const allOptions: IconOption[] = [
  ...brandIconOptions,
  ...Object.keys(categoryIcons).map((name) => ({
    iconName: `${materialIconPrefix}${name}`,
    label: autoFormatCamelCase(name),
  })),
];

export const buildIconOptions = (selectedIconName: string | undefined, searchTerm: string): IconOption[] => {
  const term = searchTerm.trim().toLocaleLowerCase();
  const matching = allOptions.filter(({ label }) => !term || label.toLocaleLowerCase().includes(term));

  const selected = matching.find((o) => o.iconName === selectedIconName);
  return selected ? [selected, ...matching.filter((o) => o !== selected)] : matching;
};
